import "@babel/polyfill";
import "url-search-params-polyfill";
import * as React from "react";
import { render, DefaultProviders } from "@mc/react-app-v4";
import App from "./App";
import "./index.scss";
import favicon from "./favicon.png";
import { Helmet } from "react-helmet";
import { ThemeContextProvider } from "@mc/react-theme-context";
import { RowsDataProvider } from "@mc/ui-v4";

render(
  <DefaultProviders
    queryClientConfig={{
      defaultOptions: {
        queries: { retry: false, refetchOnWindowFocus: false },
      },
    }}
  >
    <Helmet>
      <title>AA - soudní spory</title>
      <link href={favicon} rel={"icon"} sizes={"any"} type={"image/png"} />
    </Helmet>
    <ThemeContextProvider theme={{ ns: "ui-default" }}>
      <RowsDataProvider>
        <App />
      </RowsDataProvider>
    </ThemeContextProvider>
  </DefaultProviders>
);
